import React, { useCallback } from 'react';
import _ from 'underscore';
import { Button, mergeClasses } from '@fluentui/react-components';

import { useFlowTypeControlStyles } from './styles';

export const PublisherTypeControl = ({
  i18n, publisherTypeList, fixedAdType, switchPublisher, publisher: selectedPublisher,
}) => {
  const classes = useFlowTypeControlStyles();

  const onClickPublisher = useCallback((publisher) => {
    switchPublisher(publisher);
  }, [switchPublisher]);


  if (!publisherTypeList || !_.isArray(publisherTypeList) || publisherTypeList.length === 0) {
    return null;
  }

  return (
    <div className={mergeClasses(classes.flowTypeBox, 'publisher-type-box')}>
      {!fixedAdType && <div className={mergeClasses(classes.divider)} />}
      <Button onClick={() => { onClickPublisher(''); }} className={mergeClasses(classes.typeButton, !selectedPublisher && classes.selectedButton, 'publisher-button')}>{i18n.getString(_TL_('All publishers'))}</Button>
      <div className={mergeClasses(classes.divider)} />
      <div className={mergeClasses(classes.typeButtonBox, 'type-button-box')}>
        {publisherTypeList.map(({ name, value }) => <Button onClick={() => { onClickPublisher(value); }} className={mergeClasses(classes.typeButton, selectedPublisher === value && classes.selectedButton, 'type-button')} key={value}>{i18n.getString(name)}</Button>)}
      </div>
      <div className={mergeClasses(classes.divider)} />
    </div>
  );
};
